import { render } from "./ContactSourceProfiles.vue?vue&type=template&id=892fee88&scoped=true"
import script from "./ContactSourceProfiles.vue?vue&type=script&lang=ts"
export * from "./ContactSourceProfiles.vue?vue&type=script&lang=ts"

import "./ContactSourceProfiles.vue?vue&type=style&index=0&id=892fee88&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-892fee88"

export default script